import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormRecord, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Organization } from 'src/app/classes/organization';
import { Product } from 'src/app/classes/product';
import { Shift } from 'src/app/classes/shift';
import { SettingsService } from 'src/app/services/settings.service';
import { ShiftService } from 'src/app/services/shift.service';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-product-add',
  templateUrl: './product-add.component.html',
  styleUrls: ['./product-add.component.scss'],
})
export class ProductAddComponent  implements OnInit {
  loading = false
  shift: Shift = new Shift()
  products: Product[] = []
  related: Shift[] = []
  organization = new Organization()

  environment = environment
  fa = fa

  end!: Date
  price = 0
  conflict = false
  
  shiftForm = new FormGroup({
    products: new FormRecord({}),
  })

  constructor(private shiftService: ShiftService, 
    private settingsService: SettingsService,
    public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.settingsService.organization().subscribe(organization => {
      this.organization = organization
    })

    this.settingsService.employeeProducts(this.shift.employee_id).subscribe(products => {
      for (let product of products) {
        this.shiftForm.controls.products.addControl(product.id, new FormControl<number>(0, { nonNullable: true }))
      }

      this.products = products;
    })

    this.shiftService.shift(this.shift.id).subscribe(data => { 
      this.shift = data

      this.end = new Date(data.end)
    })
  }

  setProductInput(product: Product, event: any) {
    const ctrl = this.shiftForm.controls.products.get(`${product.id}`)

    if (Number(event.target.value) > Number(product.order_quantity_max))
      ctrl?.setValue(Number(product.order_quantity_max))
    else if (Number(event.target.value) < 0)
      ctrl?.setValue(0)
    else
      ctrl?.setValue(Number(event.target.value))

      this.updatePrice()
  }

  setProduct(product: Product, quantity: number) {
    const ctrl = this.shiftForm.controls.products.get(`${product.id}`)

    if (ctrl) {
      if (ctrl.value + quantity >= 0 && ctrl.value + quantity <= product.order_quantity_max) {
        ctrl.setValue(ctrl.value + quantity)
      }
    }

    this.updatePrice()
  }

  selectContent(event: any) {
    (event.target as HTMLInputElement).select()
  }

  setProductSingle(product: Product, event: any) {
    const ctrl = this.shiftForm.controls.products.get(`${product.id}`)

    if (ctrl) {
      if (event.target.checked) {
        ctrl.setValue(1)
      }
      else {
        ctrl.setValue(0)
      }
    }
    
    this.updatePrice()
  }

  updatePrice() {
    this.loading = true

    this.shiftService.productAdd(this.shift.id, this.shiftForm.value).subscribe((price) => {
      this.loading = false
      this.price = price.price
      this.end = new Date(price.end)
      this.conflict = price.conflict
    }, () => {
      this.loading = false
    })
  }

  save() {
    this.shiftService.productAdd(this.shift.id, this.shiftForm.value, true).subscribe((price) => {
      this.activeModal.close()
    })
  }
}
